<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="50%"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Card :bordered="false" dis-hover>
                <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 维保信息</template>
                <DescriptionList class="show-description-title" title="" :col="3" layout="vertical">
                    <Description term="零星项目：">
                        {{detail.project_name}}
                    </Description>
                    <Description term="甲方：">
                        {{detail.customer_name ?? '-'}}
                    </Description>
                    <Description term="维保标题：">
                        {{detail.title}}
                    </Description>
                    <Description term="维保类型：">
                        <Tag>{{detail.type_name}}</Tag>
                    </Description>
                    <Description term="维保金额：">
                        <Tag color="blue">{{detail.money}}</Tag>
                    </Description>
                    <Description term="负责人：">
                        {{detail.head_name}}
                    </Description>
                    <Description term="施工人员：">
                        <Tag v-for="(item,idx) in detail.work_list" :key="idx">{{item.real_name}}</Tag>
                        <span v-if="!detail.work_list || detail.work_list.length <= 0">-</span>
                    </Description>
                    <Description term="开始时间：">
                        {{detail.start_time ?? '-'}}
                    </Description>
                    <Description term="结束时间：">
                        {{detail.end_time ?? '-'}}
                    </Description>
                    <Description term="维保状态：">
                        <Tag v-if="detail.status === 1" color="orange">{{detail.status_name}}</Tag>
                        <Tag v-else-if="detail.status === 2" color="red">{{detail.status_name}}</Tag>
                        <Tag v-else-if="detail.status === 3" color="green">{{detail.status_name}}</Tag>
                        <span v-else>{{detail.status_name ?? '-'}}</span>
                    </Description>
                    <Description term="已收款金额：">
                        <strong class="text-success">{{detail.collected ?? '0.00'}}</strong>
                    </Description>
                    <Description term="支出金额：">
                        <strong class="text-orange">{{detail.expend_money ?? '0.00'}}</strong>
                    </Description>
                    <Description term="联系人：">
                        {{detail.contact_name ?? '-'}}
                    </Description>
                    <Description term="联系电话：">
                        {{detail.contact_mobile ?? '-'}}
                    </Description>
                </DescriptionList>
                <DescriptionList class="show-description-title" title="" :col="1" layout="vertical">
                    <Description term="维保说明：">
                        {{detail.m_desc ?? '-'}}
                    </Description>
                </DescriptionList>
            </Card>
            <Card :bordered="false" dis-hover>
                <template #title><Icon type="md-checkmark-circle-outline" class="text-primary" size="16" /> 审批信息</template>
                <DescriptionList class="show-description-title" title="" :col="3" layout="vertical">
                    <Description term="审批状态：">
                        <Tag v-if="detail.status === 1" color="orange">{{detail.status_name}}</Tag>
                        <Tag v-else-if="detail.status === 2" color="red">{{detail.status_name}}</Tag>
                        <Tag v-else-if="detail.status === 3" color="green">{{detail.status_name}}</Tag>
                        <span v-else>-</span>
                    </Description>
                    <Description term="审批人：">
                        {{detail.auditor_name ?? '-'}}
                    </Description>
                    <Description term="审批时间：">
                        {{detail.auditor_time || '-'}}
                    </Description>
                </DescriptionList>
                <DescriptionList class="show-description-title" title="" :col="1" layout="vertical">
                    <Description term="未通过原因：">
                        <span v-if="detail.status === 2" class="text-danger">{{detail.reject_remark || '-'}}</span>
                        <span v-else>-</span>
                    </Description>
                </DescriptionList>
            </Card>
            <Card :bordered="false" dis-hover>
                <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 其他信息</template>
                <DescriptionList class="show-description-title" title="" :col="1" layout="vertical">
                    <Description term="合同：">
                        <a href="javascript:void(0);" v-if="detail.contract" @click="FileDownload(detail.contract)">下载文件</a>
                        <span v-else>-</span>
                    </Description>
                    <Description term="备注：">
                        {{detail.remark ?? '-'}}
                    </Description>
                </DescriptionList>
            </Card>
            <Card :bordered="false" dis-hover>
                <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 收款记录</template>
                <Table size="small" stripe border :data="detail.incomeList ?? []" :columns="incomeColumns" no-data-text="暂无收款记录">
                    <template #sn="{ row }">
                        <a class="text-primary" @click="showIncome(row.income_id)">{{row.sn}}</a>
                    </template>
                    <template #status="{ row }">
                        <Badge v-if="row.status === 1" color="blue" :text="row.status_name" />
                        <Badge v-else-if="row.status === 2" color="orange" :text="row.status_name" />
                        <Badge v-else-if="row.status === 3" color="red" :text="row.status_name" />
                        <Badge v-else-if="row.status === 4" color="green" :text="row.status_name" />
                        <Badge v-else color="#999999" text="其他" />
                    </template>
                    <template #action="{ row }">
                        <a class="text-font-sm text-success" @click="showIncome(row.income_id)">查看详情</a>
                    </template>
                </Table>
            </Card>
            <Card :bordered="false" dis-hover style="margin-top: 16px;">
                <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 支出记录</template>
                <Table size="small" stripe border :data="detail.expendList ?? []" :columns="expendColumns" no-data-text="暂无支出记录">
                    <template #sn="{ row }">
                        <a class="text-primary" @click="showExpend(row.expend_id)">{{row.sn}}</a>
                    </template>
                    <template #mode="{ row }">
                        <Tag :color="row.mode === 2 ? 'orange' : 'blue'">{{row.mode_name}}</Tag>
                    </template>
                    <template #status="{ row }">
                        <Badge v-if="row.status === 1 || row.status === 2 || row.status === 3" color="blue" :text="row.status_name" />
                        <Badge v-else-if="row.status === 5" color="orange" :text="row.status_name" />
                        <Badge v-else-if="row.status === 7" color="green" :text="row.status_name" />
                        <Badge v-else-if="row.status === 4 || row.status === 6" color="red" :text="row.status_name" />
                        <Badge v-else color="#999999" text="其他" />
                    </template>
                    <template #action="{ row }">
                        <a class="text-font-sm text-success" @click="showExpend(row.expend_id)">查看详情</a>
                    </template>
                </Table>
            </Card>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">关闭</Button>
            </div>
        </div>
        <income-show v-if="is_income_show" ref="IncomeShowRef"></income-show>
        <expend-show v-if="is_expend_show" ref="ExpendShowRef"></expend-show>
    </Drawer>
</template>

<script>

import {getMaintainDetail} from "@/apis/dispersed";
import IncomeShow from "./IncomeShow";
import ExpendShow from "./ExpendShow";

export default {
    name: 'DispersedMaintainShow',
    components: {
        IncomeShow,
        ExpendShow
    },
    data () {
        return {
            title: '维保记录详情',
            isBox: false,
            detail: [],
            is_income_show: false,
            is_expend_show: false,
            incomeColumns: [
                {title: '编号', key: 'sn', slot: 'sn', minWidth: 150},
                {title: '不含税金额', key: 'money', width: 100},
                {title: '含税金额', key: 'true_money', width: 100},
                {title: '到账金额', key: 'get_money', width: 100},
                {title: '状态', key: 'status', slot: 'status', width: 100},
                {title: '申请时间', key: 'apply_time', width: 110},
                {title: '操作', key: 'action', slot: 'action', width: 90}
            ],
            expendColumns: [
                {title: '编号', key: 'sn', slot: 'sn', minWidth: 150},
                {title: '类型', key: 'mode', slot: 'mode', width: 90},
                {title: '不含税金额', key: 'money', width: 100},
                {title: '含税金额', key: 'true_money', width: 100},
                {title: '已付金额', key: 'pay_money', width: 100},
                {title: '状态', key: 'status', slot: 'status', width: 100},
                {title: '申请时间', key: 'apply_time', width: 110},
                {title: '操作', key: 'action', slot: 'action', width: 90}
            ],
            site_url : this.$siteApi,
        }
    },
    methods: {
        /**
         功能：查看收款详情
         time: 2026/09/13
         **/
        showIncome(income_id){
            this.is_income_show = true;
            this.$nextTick(() => {
                this.$refs.IncomeShowRef.show(income_id);
            });
        },
        /**
         功能：查看支出详情
         time: 2026/09/13
         **/
        showExpend(expend_id){
            this.is_expend_show = true;
            this.$nextTick(() => {
                this.$refs.ExpendShowRef.show(expend_id);
            });
        },
        /**
         功能：文件下载
         time: 2026/09/12
         **/
        FileDownload(url){
            let that = this;
            if(url){
                //下载文件
                const fileUrl = that.site_url + url; // 文件的URL地址
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.target = '_blank';
                link.setAttribute('download', fileName);
                link.click();
            }else{
                that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
            }
        },
        /**
         功能：详情
         time: 2026/09/12
         **/
        getDetail(maintain_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getMaintainDetail(maintain_id).then(e => {
                that.detail = e.data;
            })
        },
        /**
         功能：打开
         time: 2026/09/12
         **/
        show(maintain_id){
            this.isBox = true;
            if(maintain_id) this.getDetail(maintain_id);
        },
        /**
         功能：重置
         time: 2026/09/12
         **/
        FormReset(){
            this.isBox = false;
            this.title = '维保记录详情';
            this.detail = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
